import BackBtn from "../../Components/BackButton/BackButton";
import AccessForm from "../../Features/Forms/AccessForm/AccessForm";

function AccessFormPage() {
  return (
    <>
      <BackBtn></BackBtn>

      <AccessForm></AccessForm>
    </>
  );
}

export default AccessFormPage;
